<template>
    <div class="shop-section">
        <p v-if="!!$slots.preamble" class="shop-section__preamble">
            <slot name="preamble" />
        </p>
        <h2 class="shop-section__headline" v-if="!!$slots.headline">
            <slot name="headline" />
        </h2>
        <div class="orderlimit-error" v-if="!!$slots.orderlimiterror">
            <slot name="orderlimiterror" />
        </div>
        <div class="shop-section__body" v-if="!!$slots.body || !!$slots.default">
            <slot name="default"/>
            <slot name="body" />
        </div>
    </div>
</template>

<script>
    export default {
        name: "shop-section"
    }
</script>
